"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
/**
 * User entity representing users in the advertising platform
 * with authentication, profile, and business information
 */
class UserEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    username;
    role;
    /**
     * @deprecated
     */
    job;
    password;
    email;
    emailVerification;
    verified;
    /**
     * @deprecated
     */
    allowedDirect;
    not_allowed_reason;
    name;
    surname;
    isDeveloper;
    nif;
    country;
    address;
    state;
    city;
    zip;
    birthday;
    user_info_admin;
    countryInfo;
    language;
    lang;
    phone;
    newsletter;
    fingerprints;
    referral_url_id;
    referral_user;
    isOnboardingCompleted;
    onboardingCompletedSteps;
    onboardingCompletedStepsDetails;
    /**
     * @deprecated
     */
    blacklist_users;
    // Mis subscripciones
    /**
     * @deprecated
     */
    subscriptions;
    /**
     * @deprecated
     */
    following;
    /**
     * @deprecated
     */
    followers;
    /**
     * @deprecated
     */
    fav_displays;
    platformUsage;
    wallet;
    /**
     * @deprecated
     */
    comments;
    /**
     * @deprecated
     */
    notifications;
    biography;
    facebookId;
    googleId;
    /**
     * @deprecated
     */
    stripeId;
    /**
     * @deprecated
     */
    connectedStripeAccountId;
    // Objeto de stripe
    stripe;
    sellerTransparency;
    programmaticConsents;
    /**
     * @deprecated
     */
    storeSize;
    /**
     * @deprecated
     */
    profilePrivate;
    coverUrl;
    /**
     * @deprecated
     */
    profileImageUrl;
    themeMode;
    metadata;
    business;
    // Organization relationship
    organizationId;
    organizationRole; // 'owner', 'admin', 'manager', 'member', 'viewer'
    organizationJoinedAt;
    organizationInvitedBy;
    /**
     * @deprecated
     */
    retentions;
    /**
     * @deprecated
     */
    charges;
    /**
     * @deprecated
     */
    error_charges;
    integrations;
    /**
     * @deprecated
     */
    contributions;
    defaultDisplayFee;
    providerFees;
    isMe;
    /**
     * @deprecated
     */
    canViewUserDVRs;
    /**
     * @deprecated
     */
    update_at;
    /**
     * @deprecated
     */
    create_at;
    last_login_at;
    createdAt;
    updatedAt;
}
exports.UserEntity = UserEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Legacy (deprecated)",
        deprecated: true,
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the user",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Username for the user account",
        example: "john_doe_advertiser",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "username", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "User role in the system",
        example: "advertiser",
        enum: ["admin", "commercial", "translator", "user", "streamer", "franchisor"],
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "role", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Job title (deprecated)",
        deprecated: true,
        example: "Marketing Manager",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "job", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "password", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "email", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the user email has been verified",
        example: true,
    }),
    __metadata("design:type", Boolean)
], UserEntity.prototype, "emailVerification", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the user account is verified",
        example: true,
    }),
    __metadata("design:type", Boolean)
], UserEntity.prototype, "verified", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether direct streaming is allowed (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], UserEntity.prototype, "allowedDirect", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Reason why user is not allowed access, if applicable",
        example: "Account pending verification",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "not_allowed_reason", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "User first name",
        example: "John",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "name", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "User last name",
        example: "Doe",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "surname", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Boolean)
], UserEntity.prototype, "isDeveloper", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "nif", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "country", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "address", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "state", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "city", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "zip", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "birthday", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "user_info_admin", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Object)
], UserEntity.prototype, "countryInfo", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "User preferred language (full name)",
        example: "English",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "language", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "User language code",
        example: "en",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "lang", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "phone", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether user is subscribed to newsletter",
        example: true,
    }),
    __metadata("design:type", Boolean)
], UserEntity.prototype, "newsletter", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], UserEntity.prototype, "fingerprints", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Referral URL identifier if user was referred",
        example: "ref_abc123",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "referral_url_id", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "ID of the user who referred this user",
        example: "user_referrer_123",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "referral_user", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the user has completed onboarding",
        example: true,
    }),
    __metadata("design:type", Boolean)
], UserEntity.prototype, "isOnboardingCompleted", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of steps completed during onboarding",
        example: ["step1", "step2"],
    }),
    __metadata("design:type", Array)
], UserEntity.prototype, "onboardingCompletedSteps", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Detailed onboarding completion status",
        example: {
            asOwner: { completed: ["step1", "step2"], percentage: 66 },
            asAdvertiser: { completed: ["step1"], percentage: 33 },
        },
    }),
    __metadata("design:type", Object)
], UserEntity.prototype, "onboardingCompletedStepsDetails", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], UserEntity.prototype, "blacklist_users", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], UserEntity.prototype, "subscriptions", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], UserEntity.prototype, "following", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], UserEntity.prototype, "followers", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Platform usage statistics and analytics",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "platformUsage", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "wallet", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], UserEntity.prototype, "comments", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], UserEntity.prototype, "notifications", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "User biography/description",
        example: "Digital marketing professional with 10+ years of experience",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "biography", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "facebookId", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "googleId", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", String)
], UserEntity.prototype, "stripeId", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", String)
], UserEntity.prototype, "connectedStripeAccountId", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Object)
], UserEntity.prototype, "stripe", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Object)
], UserEntity.prototype, "sellerTransparency", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], UserEntity.prototype, "programmaticConsents", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Number)
], UserEntity.prototype, "storeSize", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "URL of the user cover image",
        example: "https://example.com/covers/user_cover.jpg",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "coverUrl", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Profile image URL (deprecated)",
        deprecated: true,
        example: "https://example.com/profiles/user_profile.jpg",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "profileImageUrl", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "themeMode", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Object)
], UserEntity.prototype, "metadata", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, swagger_1.ApiPropertyOptional)({
        description: "Business information (excluded from responses)",
    }),
    __metadata("design:type", Object)
], UserEntity.prototype, "business", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "organizationId", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "organizationRole", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], UserEntity.prototype, "organizationJoinedAt", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], UserEntity.prototype, "organizationInvitedBy", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], UserEntity.prototype, "retentions", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], UserEntity.prototype, "charges", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], UserEntity.prototype, "error_charges", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Object)
], UserEntity.prototype, "integrations", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], UserEntity.prototype, "contributions", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Number)
], UserEntity.prototype, "defaultDisplayFee", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], UserEntity.prototype, "providerFees", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether this user represents the current authenticated user",
        example: true,
    }),
    __metadata("design:type", Boolean)
], UserEntity.prototype, "isMe", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether user can view DVRs (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], UserEntity.prototype, "canViewUserDVRs", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], UserEntity.prototype, "update_at", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], UserEntity.prototype, "create_at", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Last login timestamp",
        type: "string",
        format: "date-time",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", Date)
], UserEntity.prototype, "last_login_at", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Creation timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Last update timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], UserEntity.prototype, "updatedAt", void 0);
